export default __webpack_public_path__ + "static/media/bg1.4b0fa90a.jpg";